<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-spin"
  [name]="name ? name : 'primary'"
  [fullScreen] = "true"
>
<h3>{{session.getAsyncMessage() | async}}</h3>
  <p i18n>
    Please wait a moment.
  </p>
</ngx-spinner>
